import { createTheme } from "@mui/material/styles";

const commonCssBaseline = (background) => ({
  styleOverrides: {
    html: {
      width: "100%",
      height: "100%",
      backgroundColor: background,
    },
    body: {
      width: "100%",
      height: "100%",
      backgroundColor: background,
      margin: 0,
      padding: 0,
    },
    "#root": {
      width: "100%",
      height: "100%",
      backgroundColor: background,
    },
  },
});

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#ff9800" },
    secondary: { main: "#103B8F" },
    background: {
      default: "#f7f7f7",
      paper: "#fff",
    },
  },
  typography: {
    fontFamily: "Plus Jakarta Sans, sans-serif",
  },
  components: {
    MuiCssBaseline: commonCssBaseline("#f7f7f7"),
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#fff",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: "#ffffff",
          borderRadius: 8,
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#faa351ff" },
    secondary: { main: "#90caf9" },
    background: {
      default: "#333",
      paper: "#444",
    },
  },
  typography: {
    fontFamily: "Plus Jakarta Sans, sans-serif",
  },
  components: {
    MuiCssBaseline: commonCssBaseline("#333"),
    MuiButton: {
      styleOverrides: {
        root: {
          color: "#ffffff",
          borderRadius: 8,
        },
      },
    },
  },
});

export const communist = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#ff0000ff" },
    secondary: { main: "#ffbdacff" },
    background: {
      default: "#a70000ff",
      paper: "#800000a6",
    },
  },
  typography: {
    fontFamily: "Plus Jakarta Sans, sans-serif",
  },
  components: {
    MuiCssBaseline: commonCssBaseline("#a70000ff"),
  },
});
